export default {
  system: {
    user: 'Benutzer',
    level: 'Level',
    earnPerTap: 'Verdienst pro Tipp',
    coinsToLevelUp: 'Münzen zum Aufleveln',
    profitPerHour: 'Gewinn pro Stunde',
    coming1: 'Hier kommt bald',
    coming2: 'etwas Interessantes...',
    close: 'Schließen',
    friends: 'Freunde',
    continue: 'Fortfahren',
  },
  settings: {
    chooseNetwork: 'Netzwerk wählen',
    chooseLanguage: 'Sprache wählen',
  },
  popup_CheckTask: {
    join: 'Beitreten',
    check: 'Überprüfen',
    taskIsNotCompleted: 'Aufgabe nicht abgeschlossen',
  },
  popup_levelUp: {
    levelUp: 'Level aufgestiegen!',
    multiTap: 'Multitipp',
    energyLimit: 'Energielimit',
  },
  popup_BalanceUp: {
    balanceUp: 'Kontostand aktualisiert!',
    balanceDiffSinceLast: 'Ihre Belohnung',
  },
  popup_BalanceTip: {
    tip: 'Steigern Sie Ihren Gewinn',
    message: 'Tippen Sie auf das Mine-Menü, um Upgrades für Ihr Netzwerk zu kaufen',
    description: 'Verdienen Sie auch offline bis zu 3 Stunden',
  },
  popup_Bored: {
    header: 'Der Frosch ist gelangweilt!',
    message: 'Spielen Sie mit dem Frosch.',
    description: 'Wenn 3 Stunden lang nicht mit dem Frosch gespielt wird, stoppt der Gewinn',
  },
  popup_Hungry: {
    header: 'Der Frosch ist hungrig!',
    message: 'Füttern Sie den Frosch.',
    description: 'Je mehr Freunde Sie haben, desto mehr Münzen kann jede Fütterung bringen',
  },
  menu: {
    network: 'Netzwerk',
    mine: 'Mine',
    earn: 'Verdienen',
    food: 'Futter',
  },
  tap: {
    bored: 'Gelangweilt',
    fun: 'Spaß',
  },
  mineMenu: {
    activities: 'Aktivitäten',
    investments: 'Investitionen',
    web3: 'WEB3',
    achievements: 'Erfolge',
  },
  leaderboard: {
    from: 'von',
    beTheFirst: 'Sei der Erste!',
  },
  mine: {
    joinOurTG1: 'Tritt unserem Telegram-Kanal bei,',
    joinOurTG2: 'um freizuschalten!',
    unlock: 'Freischalten',
  },
  friends: {
    inviteFriends: 'Lade Freunde ein!',
    receiveBonuses: 'Du und dein Freund erhalten Boni',
    inviteFriend: 'Freund einladen',
    withTelegramPremium: 'mit Telegram Premium',
    forYouAndYourFriend: 'für dich und deinen Freund',
    moreBonuses: 'Mehr Boni',
    listOfYourFriends: 'Liste deiner Freunde',
    linkCopied: 'Der Einladungslink wurde in die Zwischenablage kopiert!',
    playWithMe:
      'Spiel mit mir und verdiene Token durch einen Airdrop!\n' +
      '💰 Schnapp dir dein Geschenk! +3000 Münzen für Neulinge\n' +
      '🚀 Hast du Telegram Premium? Erhalte +5000 Münzen!\n',
  },
  earn: {
    moreCoins: 'Verdiene mehr Münzen!',
    dailyTasks: 'Tägliche Aufgaben',
    dailyReward: 'Tägliche Belohnung',
    tasksList: 'Aufgabenliste',
    joinOurTG: 'Tritt unserem Telegram-Kanal bei',
    followOurX: 'Folge unserem X-Account',
    yourAd: 'Hier könnte Ihre Werbung stehen',
    connect: 'Kontaktiere den Admin unseres Telegram-Kanals',
  },
  food: {
    hungry: 'Hungrig',
    full: 'Satt',
    frogIsFull: 'Frosch ist satt',
    feed: 'Füttern',
    bonus: 'Bonus',
    satiety: 'Sättigung',
    hours: 'Stunden',
  },
  toast: {
    buyCard: {
      title: 'Erfolg freigeschaltet!',
      subtitle: 'Zeit, dein Froschimperium zur Größe zu führen 👑',
    },
    feedFrog: {
      title: 'Der Frosch ist glücklich!',
      subtitle: 'Tolle Arbeit! Füttere dein Haustier, um die Freude aufrechtzuerhalten 🍽️',
    },
  },
};
